<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="wr_pleaseman,wr_department"
      placeholder="输入报告人、报告部门进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/oa/workreport/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.wr_code}}</p>
          <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.wr_date}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.wr_pleaseman}} {{item.wr_type}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.wr_status!='已审核'}"
          >{{item.wr_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}份</label>
    </div>
    <add-button to="/oa/workreport_edit" icon="iconfont icon-add"/>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      listUrl: "/api/oa/workreport/list",
      filters: [
        {
          type: "date",
          name: "wr_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "日报",
              condition: "wr_type=\"日报\""
            },
            {
              value: 1,
              label: "周报",
              condition: "wr_type=\"周报\""
            },
            {
              value: 2,
              label: "月报",
              condition: "wr_type=\"月报\""
            }
          ]
        }
      ]
    };
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      if(filter.value == -1) {
        this.filters[0].type = "date"
        this.filters[0].name = "wr_date"
      } else if (filter.value == 1) {
        this.filters[0].type = "date"
        this.filters[0].name = "workreport.createTime"
      } else if (filter.value == 2) {
        this.filters[0].type = "period"
        this.filters[0].name = "wr_yearmonth"
      }
      filterBar.initConfig()
      next()
    }
  }
};
</script>